var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login"},[_c('div',{staticClass:"page-login__content"},[_c('div',{staticClass:"page-login__title"},[_vm._v("\n      Login\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-login__content-wrap"},[_c('account-login',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-login-footer',{attrs:{"mode":"page"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-498fee32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-login/page-login.vue
// module id = YGiH
// module chunks = 0